import { createSlice } from "@reduxjs/toolkit";

const initialState = {
//   selectedNoteType: "",
  loading: false,
  addbillingproviderLoading: false,
//   loadingNote_Types: false,

allbillingprovider: [],
billingProviderFacility: [],
//   noteTypes: [],
//   allNotesTypes: [],
//   fieldType: [],
//   notesAgainstTypes: []
};

export const payerState = createSlice({
  name: "billingprovider",
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action?.payload
      };
    },

    setAddbillingproviderLoading(state, action) {
      return {
        ...state,
        addbillingproviderLoading: action?.payload
      };
    },

    setAllBillingProvider(state, action) {
        return {
          ...state,
          loading: false,
          allbillingprovider: action?.payload,
        //   addFacilityLoading: false
        };
      },
      setBillingProviderByFacility(state, action) {
        return {
          ...state,
          loading: false,
          billingProviderFacility: action?.payload,
        };
      },



    // Reset State
    reset() {
      return initialState;
    }
  }
});

export const {
  setLoading,
  setAddbillingproviderLoading,
  setAllBillingProvider,
  setBillingProviderByFacility
 
} = payerState.actions;
export default payerState.reducer;
